import {AssetsRequestParams} from "../../../../../infrastructure/models/params/assets-request-params";

export class GameInfoAssetsRequestParams extends AssetsRequestParams {

  constructor(name: String) {
    super();

    this.version = 3;

    this.resourceName = `${this.resourceName}/GameCenter/Info/${name}`;
  }
}
